// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'IBM Plex Mono', 'IBM Plex Mono Fallback'","fontWeight":400,"fontStyle":"normal"},"className":"__className_28c855","variable":"__variable_28c855"};